"use client";

import Link from "next/link";
import { ArrowRight, Compass } from "lucide-react";
import { AuthHeading, AuthLayout } from "@/components/auth-ui";
import { Button } from "@/components/ui/button";

/* 404 in the site's own frame: brand panel, "Need help?" bar and footer links,
   like the sign-in and contact pages. The dashboard link sends signed-out
   visitors to sign-in on its own (proxy.ts). */
export default function NotFound() {
  return <AuthLayout variant="sign-in" size="narrow">
    <div className="auth-icon-tile" aria-hidden="true"><Compass size={26} /></div>
    <AuthHeading overline="Error 404" title="Page Not Found">
      This page doesn’t exist or has moved. Check the address, or carry on from your dashboard.
    </AuthHeading>
    <div className="auth-actions">
      <Button asChild><Link href="/dashboard">Go to dashboard <ArrowRight size={16} /></Link></Button>
      <Button asChild variant="secondary"><Link href="/">Home</Link></Button>
    </div>
  </AuthLayout>;
}
